<template>
    <div class="layout-wrapper layout-1" >
        <div class="layout-inner">
            <app-layout-navbar />

            <div class="layout-container">
                <app-layout-sidenav />

                <div class="layout-content">
                    <div class="router-transitions container-fluid d-flex align-items-stretch flex-grow-1 p-0">
                        <router-view :key="$route.fullPath" />
                    </div>

                    <!-- <app-layout-footer /> -->
                </div>
            </div>
        </div>
        <div class="layout-overlay" @click="closeSidenav"></div>

        <!-- FLYOUT SUBMENU (menu colapsado) -->
        <transition name="sf-flyout">
          <div
            v-if="flyoutItem"
            class="sidebar-flyout"
            :style="{ top: flyoutTop + 'px', left: flyoutLeft + 'px' }"
            @mouseenter="onFlyoutEnter"
            @mouseleave="onFlyoutLeave"
          >
            <div class="sidebar-flyout-header">{{ flyoutItem.title }}</div>
            <div
              v-for="(subitem, subIndex) in flyoutItem.subitems"
              :key="subIndex"
              class="sidebar-flyout-item"
              :class="{ active: $route.path.toLowerCase() === subitem.link.toLowerCase() }"
              @click="onFlyoutItemClick(subitem)"
            >
              {{ subitem.title }}
            </div>
          </div>
        </transition>
        <ModalPlugin ref="modalPlugin"></ModalPlugin>
        <ModalNovidades ref="modalNovidades" :mostrarSlide="mostrarSlide"></ModalNovidades>
        <MfaPhonePrompt ref="mfaPhonePrompt"></MfaPhonePrompt>
    </div>
</template>

<style>
    .layout-wrapper{
        min-height: 400px;
    }

    /* ── Flyout submenu (menu colapsado) ─────────────────────────── */
    .sidebar-flyout {
        position: fixed;
        z-index: 9999;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid rgba(0, 0, 0, 0.08);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.10), 0 2px 8px rgba(0, 0, 0, 0.05);
        min-width: 200px;
        padding: 0.375rem;
        pointer-events: all;
    }

    .sidebar-flyout::before {
        content: '';
        position: absolute;
        left: -5px;
        top: 1.125rem;
        width: 10px;
        height: 10px;
        background: #ffffff;
        border-left: 1px solid rgba(0, 0, 0, 0.08);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        transform: rotate(45deg);
    }

    .sidebar-flyout-header {
        font-size: 0.6875rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.07em;
        color: #94a3b8;
        padding: 0.375rem 0.625rem 0.4rem;
        border-bottom: 1px solid #f1f5f9;
        margin-bottom: 0.25rem;
        white-space: nowrap;
    }

    .sidebar-flyout-item {
        display: flex;
        align-items: center;
        padding: 0.45rem 0.625rem;
        font-size: 0.8rem;
        font-weight: 450;
        color: #475569;
        border-radius: 7px;
        cursor: pointer;
        white-space: nowrap;
        min-height: 34px;
        transition: background-color 150ms ease, color 150ms ease;
    }

    .sidebar-flyout-item:hover {
        background-color: #f6f7f9;
        color: #FF5028;
    }

    .sidebar-flyout-item.active {
        background-color: rgba(255, 80, 40, 0.06);
        border: 1px solid rgba(255, 80, 40, 0.18);
        color: #FF5028;
        font-weight: 600;
        padding: calc(0.45rem - 1px) calc(0.625rem - 1px);
    }

    /* Animação de entrada */
    .sf-flyout-enter-active { transition: opacity 150ms ease, transform 150ms ease; }
    .sf-flyout-leave-active  { transition: opacity 100ms ease, transform 100ms ease; }
    .sf-flyout-enter, .sf-flyout-leave-to { opacity: 0; transform: translateX(-6px); }
</style>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import LayoutNavbar from './layoutSegfy/layoutNavbar'
import LayoutSidenav from './layoutSegfy/layoutSidenav'
import LayoutFooter from './layoutSegfy/layoutFooter'
import ModalPlugin from './modalPlugin'
import ModalNovidades from './modalNovidades'
import MfaPhonePrompt from '../../components/auth/mfaPhonePrompt'
import Cookies from 'js-cookie'
import { logoffUser } from '../../components/auth/methods.js'
import { createTour } from '../../tour/tourCore'
import { tourConfigs } from '../../tour/tourConfigs'
import { getProfilesList } from '../../components/common/vuex/automationMethods'

export default {
    name: 'app-layout-segfy',
    components: {
        'app-layout-navbar': LayoutNavbar,
        'app-layout-sidenav': LayoutSidenav,
        'app-layout-footer': LayoutFooter,
        ModalPlugin,
        ModalNovidades,
        MfaPhonePrompt
    },
    data () {
         return {
             mostrarSlide: [],
             tentativasVerificacaoExtensao: 0,
             maxTentativasVerificacao: 4,
             extensaoEncontrada: false,
             flyoutItem: null,
             flyoutTop: 0,
             flyoutLeft: 0,
             flyoutHovered: false,
             flyoutLeaveTimer: null
         }
    },
    mounted () {
        this.layoutHelpers.init()
        this.$root.$on('sidenav-flyout-show', ({ elem, rect }) => {
            clearTimeout(this.flyoutLeaveTimer)
            this.flyoutItem = elem
            this.flyoutTop = rect.top
            this.flyoutLeft = rect.right + 8
        })
        this.$root.$on('sidenav-flyout-item-leave', () => {
            this.flyoutLeaveTimer = setTimeout(() => {
                if (!this.flyoutHovered) this.flyoutItem = null
            }, 120)
        })
        this.layoutHelpers.update()
        this.layoutHelpers.setAutoUpdate(true)
        this.mostrarSlide.push(moment(process.env.VUE_APP_DATE_NOVIDADES).add(0, 'days').isAfter(new Date()) && (this.$store.state.auth.isMC || this.$store.state.auth.isOrcamentacao))
        this.mostrarSlide.push(moment(process.env.VUE_APP_DATE_NOVIDADES).add(0, 'days').isAfter(new Date()) && this.$refs.modalNovidades.clienteEscolhidoNovidades(this.$store.state.auth.assinaturaId))

        if (this.verifyNews()) {
            this.mostrarSlide.forEach(x => {
                if (x) {
                    this.$refs.modalNovidades.openModal()
                    return false
                }
            })
        }

        this.ShouldRunTour()
            .then(shouldRun => {
                if (shouldRun) {
                    setTimeout(() => {
                        const tour = createTour(tourConfigs)
                        tour.start()
                    }, 1500)
                } else {
                    this.verificarExtensaoPeriodicamente()
                    this.iniciarModalWhatsApp()
                }
            })
            .catch(err => {
                console.error('Erro ao executar ShouldRunTour:', err)
                this.verificarExtensaoPeriodicamente()
                this.iniciarModalWhatsApp()
            })
    },

    beforeDestroy () {
        this.layoutHelpers.destroy()
        this.$root.$off('sidenav-flyout-show')
        this.$root.$off('sidenav-flyout-item-leave')
    },
    updated () {
        if (window.Vue.$store.state.auth.statusAssinatura === 'Reativada' && this.$route.query.realizada === 'true') {
             logoffUser().then(resp => {
          if (process.env.VUE_APP_FAYE !== 'local') {
            window.Vue.hub.connectionFaye.pub(
              'logoff',
              window.Vue.hub.connectionFaye.uid
            )
          }
          this.logoutLegado()
          this.forgetUser()
          window.Vue.onboarding.driver.reset()
          Cookies.set('vuex', 'true', {
                      expires: -1,
                      domain: `${process.env.VUE_APP_COOKIE_DOMAIN}`
          })
          window.location.href = `${process.env.VUE_APP_SSO_FRONT}/logout?callback=${process.env.VUE_APP_SERVER}`
        })
            .catch()
        } else if (window.Vue.$store.state.auth.statusAssinatura === 'Reativada') {
            this.$router.push('/assinatura/reativar')
        }
        
        var assinado = false
        var termoAssinadoCookie = Cookies.get('termoAssinado')

        if (termoAssinadoCookie !== undefined && termoAssinadoCookie !== null) {
            assinado = termoAssinadoCookie.toLowerCase() === 'true'

            if (!assinado) {
                this.$router.push('/termos/assinarTermos')
            }
        }
    },
    methods: {
        verifyNews () {
            let inicioAssinatura = moment(moment().add(-1, 'days').format('YYYY-MM-DD'))
            if (this.$store.state.auth.dataAssinatura != null) {
                inicioAssinatura = moment(this.$store.state.auth.dataAssinatura)
            }

            let dataImplantacaoNovidades = moment(process.env.VUE_APP_DATE_NOVIDADES)
            let qtdeDias = dataImplantacaoNovidades.diff(inicioAssinatura, 'day')
            let dataLimiteMostrarNovidades = dataImplantacaoNovidades.clone().add(15, 'days')

            if (qtdeDias > 0 && dataLimiteMostrarNovidades.format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')) {
                if (!Cookies.get('modalnovidades_' + dataImplantacaoNovidades.format('YYYY-MM-DD'))) {
                    return true
                }
            }

            return false
        },

        ShouldRunTour () {
            // Verifica se já existe o cookie do tour
            const tourCookie = Cookies.get('tour_completed')
            
            if (tourCookie) {
                console.log('Tour já foi completado anteriormente')
                return Promise.resolve(false)
            }
            
            return this.callGetInsurersByToken()
                .then(result => {
                    if (!result) {
                        Cookies.set('tour_completed', 'true', {
                            expires: 30,
                            domain: process.env.VUE_APP_COOKIE_DOMAIN || undefined
                        })
                    }
                    return result
                })
                .catch(err => {
                    console.log('Erro na chamada principal do callGetInsurersByToken:', err)
                    // Mesmo em caso de erro, cria o cookie para não verificar novamente
                    Cookies.set('tour_completed', 'true', {
                        expires: 2,
                        domain: process.env.VUE_APP_COOKIE_DOMAIN || undefined
                    })
                    return false
                })
        },

        callGetInsurersByToken () {
            // Busca os perfis para verificar se há seguradoras ativas
            return getProfilesList()
                .then(profiles => {
                    // Filtra apenas perfis ativos
                    const activeProfiles = profiles.filter(profile => profile.status === 'active')
                    
                    if (activeProfiles.length === 0) {
                        return true // Deve rodar o tour se não há perfis ativos
                    }
                    
                    // Filtra perfis do usuário atual
                    const userProfiles = profiles.filter(profile => profile.user_id === this.$store.state.auth.usuarioId.toString())
                    
                    // Primeiro verifica se o usuário tem um perfil ativo
                    const userActiveProfile = userProfiles.find(profile => profile.status === 'active')

                    let selectedProfile
                    
                    if (userActiveProfile) {
                        // Usa o perfil ativo do usuário
                        selectedProfile = userActiveProfile
                    } else {
                        // Se não tem perfil ativo do usuário, usa o perfil geral (primeiro da lista de ativos)
                        selectedProfile = activeProfiles[0]
                    }

                    // Verifica se há credenciais ativas no perfil selecionado
                    if (!selectedProfile.credentials_active || selectedProfile.credentials_active === 0) {
                        return true // Deve rodar o tour se não há credenciais ativas
                    } else {
                        return false // Não deve rodar o tour se há credenciais ativas
                    }
                })
                .catch(err => {
                    console.log('Erro ao buscar perfis no layoutSegfy:', err)
                    // Não mostra erro para o usuário nem redireciona
                    return false
                })
        },

        // Só nos ramos em que o tour NÃO roda: o overlay do intro.js fica por
        // cima de qualquer modal e os dois disputariam foco e ESC.
        iniciarModalWhatsApp () {
            if (this.$refs.mfaPhonePrompt) this.$refs.mfaPhonePrompt.start()
        },

        verificarExtensaoPeriodicamente () {
            const intervalo = 5000 // 3 segundos entre cada verificação

            const verificar = () => {
                // Se já encontrou a extensão em alguma verificação anterior, não continua
                if (this.extensaoEncontrada) {
                    return
                }

                // Se atingiu o número máximo de tentativas, mostra o modal
                if (this.tentativasVerificacaoExtensao >= this.maxTentativasVerificacao) {
                    // Outro modal aberto (ex.: o do WhatsApp, com a pessoa
                    // esperando o código): espera em vez de empilhar por cima.
                    if (document.querySelector('.modal.show')) {
                        setTimeout(verificar, intervalo)
                        return
                    }
                    this.$refs.modalPlugin.openModal()
                    return
                }

                console.log('Verificação da extensão - Tentativa:', this.tentativasVerificacaoExtensao + 1)
                
                // Usa o método verifyInstall para fazer a verificação
                if (!this.verifyInstall()) {
                    console.log('Extensão encontrada!')
                    this.extensaoEncontrada = true
                    return
                }

                // Se não encontrou a extensão, incrementa o contador e tenta novamente
                this.tentativasVerificacaoExtensao++
                setTimeout(verificar, intervalo)
            }

            // Inicia a primeira verificação após 1 segundo
            setTimeout(verificar, 1000)
        },

        verifyInstall () {
            if (this.isMobile) return false

            // Se já encontrou a extensão em alguma verificação anterior, retorna false
            if (this.extensaoEncontrada) {
                return false
            }

            var element = document.getElementById('extension-version')
            if (element) {
                console.log('Extensão encontrada!')
                this.extensaoEncontrada = true
                return false
            }

            var modalplugin = Cookies.get('modalplugin')
            if (modalplugin) {
                return false
            }

            return true
        },
        onFlyoutEnter () {
            clearTimeout(this.flyoutLeaveTimer)
            this.flyoutHovered = true
        },
        onFlyoutLeave () {
            this.flyoutHovered = false
            this.flyoutItem = null
        },
        onFlyoutItemClick (subitem) {
            this.flyoutItem = null
            this.$root.$emit('sidenav-flyout-item-click', subitem)
        },
        closeSidenav () {
            this.layoutHelpers.setCollapsed(true)
        },
        ...mapActions({
            forgetUser: 'auth/forgetUser',
            toggleSideMenu: 'settings/toggleSideMenu'
        })
    }
}
</script>
